import {
    FormGroupInput,
    FormAddress,
    FormPhone,
    Card,
    DropDown,
    Button,
    EditInput,
    Multiselect
} from "../components/index";

// import bModal from "bootstrap-vue/es/components/modal/modal";
// import bFormFile from "bootstrap-vue/es/components/form-file/form-file";
// import bFormCheckbox from "bootstrap-vue/es/components/form-checkbox/form-checkbox";
// import bFormCheckboxGroup from "bootstrap-vue/es/components/form-checkbox/form-checkbox-group";

import {
    BModal,
    BFormFile,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormDatepicker
} from "bootstrap-vue";


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
    install(Vue) {
        Vue.component("fg-input", FormGroupInput);
        Vue.component("fg-address", FormAddress);
        Vue.component("fg-phone", FormPhone);
        Vue.component("drop-down", DropDown);
        Vue.component("card", Card);
        Vue.component("p-button", Button);
        Vue.component("fg-input-edit", EditInput);
        Vue.component("multiselect", Multiselect);
        Vue.component("b-modal", BModal);
        Vue.component("b-form-file", BFormFile);
        Vue.component("b-form-checkbox", BFormCheckbox);
        Vue.component("b-form-checkbox-group", BFormCheckboxGroup);
        Vue.component("b-form-datepicker", BFormDatepicker);
    }
};

export default GlobalComponents;
